"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.weaveDesign = weaveDesign;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
const dist_2 = require("../../core/dist");
const dist_3 = require("../../core/dist");
const dist_4 = require("../../core/dist");
const chatNames_1 = require("./utils/chatNames");
const resolveThreadFolder_1 = require("./utils/resolveThreadFolder");
/**
 * Finds any idea document in the weave directory (temporary or finalized).
 */
async function findIdeaFile(weavePath, deps) {
    const entries = await deps.fs.readdir(weavePath, { withFileTypes: true });
    for (const entry of entries) {
        if (!entry.isFile() || !entry.name.endsWith('-idea.md'))
            continue;
        const ideaPath = path.join(weavePath, entry.name);
        const content = await deps.fs.readFile(ideaPath, 'utf8');
        const idMatch = content.match(/^id:\s*["']?(.+?)["']?\s*$/m);
        const titleMatch = content.match(/^title:\s*["']?(.+?)["']?\s*$/m);
        const statusMatch = content.match(/^status:\s*["']?(.+?)["']?\s*$/m);
        return {
            id: idMatch ? idMatch[1] : path.basename(entry.name, '.md'),
            title: titleMatch ? titleMatch[1] : path.basename(entry.name, '-idea.md'),
            status: statusMatch ? statusMatch[1] : 'draft',
            filePath: ideaPath,
            content,
        };
    }
    return null;
}
/**
 * Finalizes a draft idea = flips its status to active. The permanent ULID id and
 * the filename are left as created — finalize never re-mints the id from the title.
 */
async function finalizeIdea(ideaPath, deps) {
    const idea = await deps.loadDoc(ideaPath);
    if (idea.status !== 'draft') {
        return { newId: idea.id, title: idea.title };
    }
    const updatedIdea = {
        ...idea,
        status: 'active',
        updated: (0, dist_3.today)(),
    };
    await deps.saveDoc(updatedIdea, ideaPath);
    return { newId: idea.id, title: idea.title };
}
/**
 * Creates a new design document.
 * If an idea exists in the weave, it is used as the parent (and auto‑finalized if temporary).
 * If no idea exists, the design is created with no parent.
 */
async function weaveDesign(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    // Invariant: every doc lives in a thread, referenced by its stable th_ ULID.
    // Weave-root design creation is retired — a thread_ulid is required.
    if (!input.threadUlid) {
        throw new Error('Cannot create a design: a thread_ulid is required. Create the thread first (createThread) and pass its returned thread_ulid.');
    }
    // Resolve the thread by its stable ULID → folder (never fabricates).
    const { threadSlug, threadPath } = await (0, resolveThreadFolder_1.resolveThreadFolder)(input.weaveSlug, input.threadUlid, deps);
    const ideaPath = path.join(threadPath, 'idea.md');
    const hasIdea = await deps.fs.pathExists(ideaPath);
    let parentId = null;
    let designTitle = input.title || threadSlug;
    let ideaVersion;
    if (hasIdea) {
        const idea = await deps.loadDoc(ideaPath);
        parentId = idea.id;
        designTitle = input.title || idea.title;
        ideaVersion = idea.version;
    }
    const id = (0, dist_1.generateDocId)('design');
    const frontmatter = (0, dist_2.createBaseFrontmatter)('design', id, designTitle, parentId);
    const content = input.content ?? (0, dist_4.generateDesignBody)(designTitle, (0, chatNames_1.getUserName)(loomRoot));
    // Stamp the idea version this design was built against (its staleness baseline).
    const doc = { ...frontmatter, content, ...(ideaVersion !== undefined ? { idea_version: ideaVersion } : {}) };
    const filePath = path.join(threadPath, (0, dist_1.singletonFileName)('design'));
    await deps.saveDoc(doc, filePath);
    return { id, filePath, autoFinalized: false };
}
